/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class GovernmentEndorsements {
  governmentEndorsementId: number;
  endorsementName: string;
  regionId: number;
  regionName: string;
}
